import { render, staticRenderFns } from "./UserDetailsAdministratorForm.vue?vue&type=template&id=705a81a4&"
import script from "./UserDetailsAdministratorForm.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports